<template>
  <v-data-table
    :headers="headersGruposSolucao"
    :items="grupoSolutions"
    item-key="municipioGrupoSolucao.municipioGrupoSolucaoId"
    class="elevation-1 rejeitada"
    loading-text="Obtendo informações ..."
    show-expand
    single-expand
    hide-default-footer
    disable-pagination
    @item-expanded="getSolutions"
  >
    <template v-slot:item.andamento="{ item }">
      {{ item.solucoesConcluidas }} / {{ item.totalSolucoes }}
    </template>

    <template v-slot:item.percental="{ item }">
      {{ item.percentual }} %
    </template>
    <template v-slot:expanded-item="{ item }">
      <td colspan="4" class="td-without-padding">
        <app-solutions-table
          :solutions="solucoes"
          :loading="loadingSolutions"
        ></app-solutions-table>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import AppSolutionsTable from './SolutionsTable'
import { administrativeDashboardAPI } from '@/modules/administrative-dashboard'

export default {
  components: {
    AppSolutionsTable
  },
  props: {
    grupoSolutions: { type: Array, required: true }
  },
  data () {
    return {
      headersGruposSolucao: [
        {
          text: 'Nome do Grupo de Solução',
          value: 'municipioGrupoSolucao.nome'
        },
        { text: 'Andamento', value: 'andamento' },
        { text: 'Percentual', value: 'percentual' }
      ],
      solucoes: [],
      loadingSolutions: true
    }
  },
  methods: {
    getSolutions (item) {
      this.solucoes = []
      this.loadingSolutions = true
      administrativeDashboardAPI
        .getDashboardSolucoes(
          item.item.municipioGrupoSolucao.municipioGrupoSolucaoId
        )
        .then((resp) => {
          this.solucoes = resp.data
          this.loadingSolutions = false
        })
        .catch((resp) => {
          this.$notification.error('Erro ao buscar soluções')
          this.loadingSolutions = false
        })
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
